// extracted by mini-css-extract-plugin
export default {"melodyVideo":"nP-z","isFullWidth":"oP-z","landingPageVideo":"pP-z","play":"qP-z","iframeVideo":"rP-z","playHidden":"sP-z","fullwidth":"tP-z"};